import React, { useState } from 'react'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import { template } from 'lodash'
import { Menu, MenuItem, ListItemIcon, ListItemText, IconButton } from '@mui/material'
import { MoreVert, FileDownload, DeleteOutline } from '@mui/icons-material'
import { useDispatch } from 'react-redux'
import ConfirmModal from 'components/modal/ConfirmModal'
import JobAction from 'import/actions/JobAction'
import FileAction from './FileAction'
import { getDownloadPayload, isFolder } from './FtpUtils'

const FtpItemMenu = ({ item, onReload }) => {
    const dispatch = useDispatch()
    const [anchor, setAnchor] = useState(null)
    const [isConfirmOpen, setIsConfirmOpen] = useState(false)

    const isFolderNode = isFolder(item)

    const handleDeleteClick = () => {
        setAnchor(null)
        setIsConfirmOpen(true)
    }

    const handleConfirmValidate = () => {
        setIsConfirmOpen(false)
        const action = isFolderNode
            ? FileAction.deleteDir(item.path, onReload)
            : FileAction.deleteFile(item.path, onReload)
        dispatch(action)
    }

    return (
        <>
            <IconButton
                size='small'
                onClick={(e) => {
                    e.stopPropagation()
                    setAnchor(e.currentTarget)
                }}
                sx={{ opacity: 0.7, '&:hover': { opacity: 1 }, color: 'text.secondary' }}
            >
                <MoreVert fontSize='small' />
            </IconButton>
            {!!anchor && (
                <Menu
                    anchorEl={anchor}
                    open={!!anchor}
                    onClose={() => setAnchor(null)}
                    onClick={(e) => e.stopPropagation()}
                    PaperProps={{ sx: { borderRadius: 2, boxShadow: '0 4px 20px rgba(0,0,0,0.12)', minWidth: 180 } }}
                >
                    {((isFolderNode && item.depth > 0) || !isFolderNode) && (
                        <>
                            <MenuItem
                                onClick={() => {
                                    setAnchor(null)
                                    if (!isFolderNode) {
                                        const { downloadName, relativePath } = getDownloadPayload(item)
                                        dispatch(JobAction.downloadFile(downloadName, relativePath))
                                    } else {
                                        dispatch(FileAction.zipDir(item.path, (zipPath) => {
                                            dispatch(JobAction.downloadFile(`${item.label}.zip`, zipPath))
                                        }))
                                    }
                                }}
                            >
                                <ListItemIcon>
                                    <FileDownload fontSize='small' sx={{ color: 'text.secondary' }} />
                                </ListItemIcon>
                                <ListItemText>{i18n.download}</ListItemText>
                            </MenuItem>
                            <MenuItem onClick={handleDeleteClick}>
                                <ListItemIcon>
                                    <DeleteOutline fontSize='small' sx={{ color: 'error.main' }} />
                                </ListItemIcon>
                                <ListItemText sx={{ color: 'error.main' }}>
                                    {i18n.delete}
                                </ListItemText>
                            </MenuItem>
                        </>
                    )}
                </Menu>
            )}
            {isConfirmOpen && (
                <ConfirmModal
                    isOpen={isConfirmOpen}
                    title={i18n.ftpConfirmDeleteTitle}
                    subTitle={template(i18n.ftpConfirmDeleteMessage)({ name: item.label || item.id })}
                    onValidate={handleConfirmValidate}
                    onClose={() => setIsConfirmOpen(false)}
                />
            )}
        </>
    )
}

FtpItemMenu.propTypes = {
    item: PropTypes.object.isRequired,
    onReload: PropTypes.func.isRequired,
}

export default FtpItemMenu
